/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import { getApiUrl } from "@/utils/baseUrl";

export interface WeatherDay {
  date: string; // ISO date
  weatherCode: number;
  tempMax: number;
  tempMin: number;
}

export interface Weather {
  location: string;
  temperature: number;
  apparentTemperature: number;
  weatherCode: number;
  condition: string;
  windSpeed: number; // km/h
  humidity: number; // %
  isDay: boolean;
  units: "celsius" | "fahrenheit";
  updatedAt: string;
  daily: WeatherDay[];
}

// GET /weather -- backend proxies Open-Meteo for the location configured in
// Settings and caches the response. 404 / "not configured" means no location
// has been set yet; the widget renders a set-up prompt in that case.
export async function getWeather(): Promise<Weather | null> {
  const response = await fetch(getApiUrl("/weather"));
  if (response.status === 404 || response.status === 501) return null;
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || "Failed to fetch weather");
  }
  const data = await response.json();
  if (!data || data.configured === false) return null;
  return data as Weather;
}
